'use strict';

import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import PlanItemSection from "./PlanItemSection";
import {PlanViewType} from "../lib/Constants";

/**
 * Component for displaying a list of plan item course sections
 */
const PlanItemSectionList = ({planItem = {}, viewType = PlanViewType.plan, sendToRegistration}) => {
    const sections = planItem.planActivities;
    if ( sections.length === 0 ) {
        return null;
    }

    let sectionsList = sections.map( (section, index) => {
        // section list length is odd
        let isOdd = sections.length % 2 === 1;
        // section item is the last in the list
        let isLast = sections.length === index + 1;

        let listItemClasses = classnames(
            {"list-inline-item m-0": viewType === PlanViewType.plan},
            // Use 6 cols when list is more than 1 and either is not the last item or is the last item with an even length
            {"col-6": viewType === PlanViewType.plan && sections.length > 1 && (!isLast || isLast && !isOdd)},
            // Use 12 cols if list is 1 or item is last in odd length list
            {"col-12": viewType === PlanViewType.plan && isOdd && isLast}
        );
        return (
            <li key={index} className={listItemClasses}>
                <PlanItemSection planItem={planItem} section={section} viewType={viewType} sendToRegistration={sendToRegistration} />
            </li>
        );
    });

    let listClasses = classnames(
        {"list-unstyled list-add-space mt-2": viewType === PlanViewType.reg},
        {"list-inline row": viewType === PlanViewType.plan}
    );

    return (
        <ul aria-label="Course Sections" className={listClasses}>
            {sectionsList}
        </ul>
    );
}

PlanItemSectionList.propTypes = {
    planItem: PropTypes.object.isRequired,
    viewType: PropTypes.oneOf(Object.keys(PlanViewType)).isRequired,
    sendToRegistration: PropTypes.bool.isRequired
};

export default PlanItemSectionList;